import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { ROUTE_ORGANIZATION, ROUTE_PROFILE } from './app-route.constants';
import { SessionAuthGuard } from './core/session/session-auth.guard';
import { AfterLoginComponent } from './login/after-login.component';
import { ProfileDetailComponent } from './login/profile-detail.component';



const routes: Routes = [
  { path: '', component: AfterLoginComponent },
  { path: `${ROUTE_PROFILE}`, component: ProfileDetailComponent, canActivate: [SessionAuthGuard] },
  {
    path: `${ROUTE_ORGANIZATION}`,
    loadChildren: () => import('./features/organizations/organization.module').then(m => m.OrganizationModule),
    canActivate: [SessionAuthGuard],
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
